var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useMemo } from 'react';
import { TrayContainer, TrayWrapper, TrayContent, NoNotificationsSign, TopButtons, TopButtonsText, } from './styles';
import { NOTIFICATIONS_API, getData } from 'src/Utils';
import { useInfiniteQuery, useMutation, useQueryCache } from 'react-query';
import Notification from './Notification';
import NotificationsPagination from './NotificationsPagination';
import Skeleton from 'react-loading-skeleton';
import Button from 'src/Components/Common/AdminButton/Button';
import api from 'src/Utils/api';
function NotificationsTray() {
    var _this = this;
    var queryCache = useQueryCache();
    var _a = useInfiniteQuery(NOTIFICATIONS_API, function (_key, page) {
        if (page === void 0) { page = 1; }
        return getData('/ticket_notifications', {
            page: page,
        });
    }, {
        getFetchMore: function (lastPage, allPages) {
            var _a;
            var currentPage = allPages.length;
            var totalPages = (_a = lastPage.total_pages) !== null && _a !== void 0 ? _a : 1;
            return currentPage < totalPages ? currentPage + 1 : false;
        },
    }), data = _a.data, isFetching = _a.isFetching, fetchMore = _a.fetchMore, canFetchMore = _a.canFetchMore;
    var _b = useMutation(function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, api.put('/ticket_notifications', {})];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () {
            queryCache.invalidateQueries(NOTIFICATIONS_API);
        },
    }), markAllAsRead = _b[0], markAllAsReadResult = _b[1];
    var handleMarkAllAsRead = function (event) {
        event.stopPropagation();
        markAllAsRead();
    };
    var notifications = useMemo(function () {
        if (!data)
            return [];
        var byId = new Map();
        data.forEach(function (pageData) {
            pageData.ticket_notifications.forEach(function (notification) {
                byId.set(notification.id, notification);
            });
        });
        return Array.from(byId.values());
    }, [data]);
    var content = [];
    if (isFetching && notifications.length === 0) {
        content = Array(5)
            .fill(0)
            .map(function (_, index) { return (React.createElement(Skeleton, { key: index, width: "100%", height: 90, borderRadius: 10 })); });
    }
    else if (notifications.length > 0) {
        content = notifications.map(function (notification) { return (React.createElement(Notification, { key: notification.id, notification: notification })); });
    }
    else {
        content = (React.createElement(NoNotificationsSign, null, "No hay notificaciones pendientes"));
    }
    return (React.createElement(TrayWrapper, null,
        React.createElement(TrayContainer, null,
            React.createElement(TopButtons, null,
                React.createElement(Button, { disabled: markAllAsReadResult.isLoading, className: "full-width", onClick: handleMarkAllAsRead },
                    React.createElement(TopButtonsText, null, "Marcar todas como le\u00EDdas"))),
            React.createElement(TrayContent, null,
                content,
                React.createElement(NotificationsPagination, { hasNextPage: !!canFetchMore, onLoadMore: function () { return fetchMore(); } })))));
}
export default NotificationsTray;
